import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import cx from "classnames";
import { history } from "../_config/history.config";
import { TextInput } from "../_components/text-input.component";
import { Button } from "../_components/button.component";
import { createSession } from "../_store/_actions/auth.actions";
import { AuthService } from "../_service/auth.service";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { FORGOT_PASSWORD_ROUTE } from "./forgot-password.page";
import userIcon from "../_assets/images/User.png";
import lockIcon from "../_assets/images/Lock.png";
import { UserService } from "../_service/user.service";

export const LOGIN_ROUTE = "/login";

function LoginPageComponent({ addToast }) {
  // const [isFormSubmitable, setIsFormSubmitable] = useState(false); // to disable submit button
  const [email, setEmail] = useState(""); // to save email
  const [password, setPassword] = useState(""); // to save password
  const [passwordType, setPasswordType] = useState(false); // to save password

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const isFormSubmitable =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) &&
    password.length > 2;

  const submitForm = (event) => {
    event.preventDefault();
    setIsLoading(true);
    AuthService.signin(email, password)
      .then((data) => {
        setIsLoading(false);
        dispatch(createSession({ token: data.token }));
        history.push("/");
        localStorage.setItem("token", JSON.stringify(data.token));

        UserService.getUserProfile(data.token)
          .then((response) => {
            // save the user
            localStorage.setItem(
              "user",
              JSON.stringify({
                token: data.token,
                email: response.email ? response.email : response.email,
                name: response.name,
                role: response.roles[0] ? response.roles[0] : null,
              })
            );

            dispatch(
              createSession({
                token: data.token,
                email: response.email ? response.email : response.email,
                name: response.name,
                role: response.roles[0] ? response.roles[0] : null,
              })
            );
          })
          .catch((err) => {
            console.log({ err });
          });
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  return (
    <div className="LoginPage">
      <div className="h-screen flex justify-center items-center">
        <div className="relative">
          <div className="">
            <p className="font-bold mb-11 text-3xl text-center text-primary">
              Vitalize Admin Dashboard
            </p>
          </div>
          <form onSubmit={submitForm}>
            <TextInput
              prefix={
                <div className="flexd items-center justify-center">
                  <img
                    src={userIcon}
                    alt="User Icon"
                    width="15"
                    className="ml-4 transform"
                  />
                </div>
              }
              noPrefixSeperator
              noBorder
              validationOutsideBox
              // noMargin
              type="text"
              placeholder="Enter Email"
              validator={(value) => {
                if (
                  !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                    value
                  )
                ) {
                  return "Email is not valid!";
                }
              }}
              containerClassName="py-1 focus:outline-none border theme-border-default theme-bg-surface rounded-xl"
              value={email}
              className="py-2 ml-2"
              onChange={(value) => {
                setEmail(value);
              }}
            />
            <TextInput
              prefix={
                <div className="flexd items-center justify-center">
                  <img
                    src={lockIcon}
                    alt="Lock Icon"
                    width="15"
                    className="ml-4 transform"
                  />
                </div>
              }
              noPrefixSeperator
              noBorder
              validationOutsideBox
              type={!passwordType ? "password" : "text"}
              placeholder="Enter Password"
              containerClassName="py-1 focus:outline-none border theme-border-default theme-bg-surface rounded-xl"
              className="py-2 ml-2"
              value={password}
              postfix={
                <div
                  onClick={() => setPasswordType(!passwordType)}
                  className="text-xxs text-yellow-500 mr-1 cursor-pointer">
                  {!passwordType ? "SHOW" : "HIDE"}
                </div>
              }
              onChange={(value) => {
                setPassword(value);
              }}
            />
            <span
              className="text-primary cursor-pointer"
              onClick={() => history.push(FORGOT_PASSWORD_ROUTE)}>
              Forgot Password
            </span>
            <div className="flex justify-center mt-2">
              <Button
                disabled={!isFormSubmitable}
                type="submit"
                className="mt-2 px-5 py-3.5 w-1/2 text-lg rounded-2xl"
                isLoading={isLoading}
                label="Log In"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const LoginPage = withToast(LoginPageComponent);

export default LoginPage;
